var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestTabletSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 14,
  viewBox: "0 0 19 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m18.8 0-2.46 13-4.829-1.635-3.694 2.37-.107-3.675.01.005 6.996-6.003 1.054-1.37L5.685 9.032l-2.748-.335L0 7.596 16.957.402z"
})));
export default SvgPinterestTabletSend;